import { Injectable } from '@angular/core';

@Injectable()
export class AlertMessagesConfig {
  readonly defaultServerError =
    'We\'re having trouble connecting to our server. Try reloading or checking your internet connection.';

  readonly applicationLockedError =
    'This application is currently locked and cannot be opened for editing. It has been opened in view mode.'
    
  }
  
  export class AlertMessages {
    static readonly defaultServerError =
    'We\'re having trouble connecting to our server. Try reloading or checking your internet connection.';
  
    static readonly applicationLockedError =
      'This application is currently locked and cannot be opened for editing. It has been opened in view mode.'
}
